import React, { useState } from 'react';
import { getMatchStreamingProps } from '../data/streaming/streamingUtils';
import { filterBetsByNumberOfOdds, filtraParametriche, iconCategoryCssClass, iconSportCssClass } from '../data/utils';
import BetsOddsHeader from './BetsOddsHeader';
import TournamentLiveMatch from './TournamentLiveMatch';
import { getLabel } from '../InitData';

function FavouritesListSport(props) {
    const [toggled, setToggled] = useState(true);
    
    return (
        <>
            <div className="bg-nero bianco titolo-blocco-sport pointer" onClick={() => setToggled(!toggled)}>
                <span className="d-centro-v maiuscolo">
                        <div className={"img-fluid icona-sport margine-dx-mezzo ico-sport icoSport" + props.id}></div>
                        {props.tournaments[0][0].sportDesc}
                </span>
            </div>
            {toggled &&
                <>
                    {props.tournaments.map((tournamentMatches, index) => {
                        const tournamentFirstMatch = tournamentMatches[0];
                        let bets = tournamentFirstMatch.bets;
                        bets = filtraParametriche(bets);
                        bets = filterBetsByNumberOfOdds(bets);
                        const icoSport = iconSportCssClass(tournamentFirstMatch.sportRef,tournamentFirstMatch.iconClass);
                        const icoCategory = iconCategoryCssClass(tournamentFirstMatch.sportRef, tournamentFirstMatch.categoryRef, tournamentFirstMatch.iconClass)
                        return (
                            <div key={index} className="contenitore-table bg-bianco">
                                <div className={"titolo-competizione-live bg-grigio-scuro pointer bianco bordo-tondo margine-giu-mezzo toggle-nascondi-live "+(props.collapse?'collapsed':'')} data-toggle="collapse" data-target={"#tournament-collapse-" + tournamentFirstMatch.tournamentRef}>
                                    <div className={`img-fluid img-flags margine-dx-mezzo ico-cat ${icoSport}`}></div>
                                    <div className={`img-fluid img-flags margine-dx-mezzo ico-cat ${icoCategory}`}></div>
                                    <span>{tournamentFirstMatch.tournamentDesc}</span>
                                </div>
                                <div className={!props.collapse?'collapse show':'collapse'} id={"tournament-collapse-" + tournamentFirstMatch.tournamentRef}>
                                    <div className="collapse show" id="paese-calcio-1-aa">
                                        <div className="tabellaQuoteIntestazione text_s1 mb-2">
                                            <div className="tabellaQuoteTempo d-flex justify-content-center align-items-center pointer">
                                                <div className={"sortContainer "}>
                                                    <i className="fas fa-sort-up"></i>
                                                    <i className="fas fa-sort-down"></i>
                                                </div>
                                                <p>{getLabel('live_page.tournament_header.time')}</p>
                                            </div>
                                            <div className="tabellaQuoteCampetto">&nbsp;</div>
                                            <div className="tabellaQuoteSquadre d-flex justify-content-center align-items-center"></div>
                                            <div className="tabellaQuoteContenitoreQuotazioni d-flex justify-content-end align-items-center flex-grow-1">
                                                <BetsOddsHeader bets={bets} />
                                            </div>
                                            <div className="tabellaQuoteStatistiche"></div>
                                            <div className="tabellaQuoteAltre d-flex justify-content-center align-items-center"></div>
                                        </div>
                                        {tournamentMatches.map(function(mData){
                                            const streamingMap = getMatchStreamingProps(mData);
                                            return <TournamentLiveMatch key={mData.id}
                                                                        match={mData}
                                                                        changeMatch={props.changeMatch}
                                                                        selected={props.currentMatch === mData.id}
                                                                        streaming={streamingMap && streamingMap[mData.id]}
                                                                        isLiveSuite={props.isLiveSuite}
                                                                        openWidget={index===0} />
                                        })}
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </>
            }
        </>
    );
}

export default FavouritesListSport;